/** Link chia sẻ công khai (không có prefix /my) */
export function buildTsaTrialPublicLink(code) {
  const domain = (process.env.REACT_APP_DOMAIN || process.env.PUBLIC_URL || '')
    .replace(/\/$/, '');
  return `${domain}/link/${code}`;
}
